import { Box, Chip, Typography } from '@mui/material'
import { compact } from 'lodash'

type PracticeContactInfoProps = {
  inquiries: string
  notifications: string
}

const parse = (value: string) => compact((value ?? '').split(',').map(v => v.trim()))

const ContactGroup: React.FC<{ label: string, values: string[] }> = ({ label, values }) => (
  <>
    <Typography>{label}:</Typography>
    {values.length ? values.map(value => (
      <Chip key={value} size='small' label={value} />
    )) : <Typography>N/A</Typography>}
  </>
)

const PracticeContactInfo: React.FC<PracticeContactInfoProps> = ({ inquiries, notifications }) => (
  <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
    <ContactGroup label='Inquiries' values={parse(inquiries)} />
    <ContactGroup label='Notifications' values={parse(notifications)} />
  </Box>
)

export default PracticeContactInfo
